export function PhysicalDamageIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" {...props}>
      {/* truck body */}
      <rect x="4" y="14" width="26" height="16" rx="2" fill="#8B5CF6" opacity="0.15" />
      <rect x="4" y="14" width="26" height="16" rx="2" stroke="#8B5CF6" strokeWidth="2.5" />
      {/* cab */}
      <path d="M30 20h6l4 6v4h-10V20z" fill="#8B5CF6" opacity="0.15" />
      <path d="M30 20h6l4 6v4h-10V20z" stroke="#8B5CF6" strokeWidth="2.5" strokeLinejoin="round" />
      {/* wheels */}
      <circle cx="12" cy="32" r="3" fill="#8B5CF6" />
      <circle cx="36" cy="32" r="3" fill="#8B5CF6" />
      {/* protection sparkle */}
      <path
        d="M20 10l1.5 3 3-1-1 3 3 1.5-3 1 1 3-3-1-1.5 3-1.5-3-3 1 1-3-3-1.5 3-1-1-3 3 1z"
        fill="#8B5CF6"
        opacity="0.6"
      />
    </svg>
  )
}
